import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles(({
  root: {},
  item: {
    // display: 'flex',flexDirection: 'column',
    // margin: '5px'
  },
  footerBackground:{
    background:"#f7f7f7"
  },
  paper: {textAlign: 'center'},
  companyHeadings: {backgroundColor: '#4688f0', color: '#fff',},
  titleTag: {margin: 'auto',},
  inputAll: {},
  listChecks: {},
  footerBox: {},
  width100: {width: '100%',},
  pdLL: {paddingLeft:'40px',},
  finalBoxTable: {},
}));